export default {
  "errors": {
    "notFound": "Événement introuvable.",
    "disabled": "Les RSVP en ligne ne sont pas activés pour cet événement.",
    "loadError": "Impossible de charger la page.",
    "searchError": "Nous n'avons pas pu trouver votre invitation. Veuillez vérifier l'orthographe exacte utilisée sur votre faire-part.",
    "genericError": "Une erreur est survenue.",
    "submitError": "Erreur lors de la soumission de votre réponse."
  },
  "success": {
    "title": "Merci !",
    "message": "Votre réponse a été enregistrée avec succès.",
    "dateMessage": "Rendez-vous le {{date}} !"
  },
  "header": {
    "title": "RSVP",
    "defaultWelcome": "Nous sommes impatients de célébrer avec vous ! Veuillez confirmer votre présence."
  },
  "search": {
    "title": "Trouvez votre invitation",
    "firstName": "Prénom",
    "firstNamePlaceholder": "Jean",
    "lastName": "Nom",
    "lastNamePlaceholder": "Dupont (Optionnel)",
    "submit": "Rechercher",
    "searching": "Recherche..."
  },
  "form": {
    "greeting": "Bonjour, {{firstName}} {{lastName}} !",
    "subtitle": "Veuillez nous indiquer si vous serez parmi nous.",
    "attendance": "Serez-vous présent(e) ?",
    "yes": "Oui, avec plaisir !",
    "no": "Non, je regrette",
    "plusOne": {
      "title": "Votre accompagnant (+1)",
      "label": "Prénom et Nom de l'accompagnant",
      "placeholder": "Marie Martin"
    },
    "dietary": {
      "title": "Régimes alimentaires",
      "subtitle": "Cochez les options applicables pour vous (et votre accompagnant si applicable).",
      "vegetarian": "Végétarien",
      "vegan": "Vegan",
      "glutenFree": "Sans Gluten",
      "porkFree": "Sans Porc",
      "nutAllergy": "Allergie aux fruits à coque",
      "seafoodAllergy": "Allergie aux fruits de mer",
      "customPlaceholder": "Autre précision (allergies spécifiques...)"
    },
    "message": {
      "title": "Un mot pour les mariés ?",
      "placeholder": "Laissez un petit mot doux..."
    },
    "submit": "Confirmer ma réponse",
    "submitting": "Confirmation en cours..."
  }
};
